import Box from '../../../../Global/Box'
import {
  findArrayStatus,
  fnObjNameStatus,
} from '../../../../../const/constStatuses'
import GetTicketsCountItem from './GetTicketsCountItem'

const objNameStatus = fnObjNameStatus()
const st_nuevo = findArrayStatus(objNameStatus.nuevo)
const st_pendiente = findArrayStatus(objNameStatus.pendiente)
const st_planificar = findArrayStatus(objNameStatus.planificar)
const st_procesar = findArrayStatus(objNameStatus.procesar)
const st_asignar = findArrayStatus(objNameStatus.asignar)
const st_validacion_inicial = findArrayStatus(objNameStatus.validacion_inicial)
const st_validacion_final = findArrayStatus(objNameStatus.validacion_final)
const st_completado = findArrayStatus(objNameStatus.completado)
const st_rechazar = findArrayStatus(objNameStatus.rechazar)

const GetTicketsCount = ({ filters }) => {
  return (
    <Box
      classNameHeader="card-header py-1 bg-info"
      contentHeader={
        <h3 className="card-title pl-3 mt-0">
          <div className="text-white">
            <i className={`fas fa-calculator pr-2`} />
            Total de tickets / estatus
          </div>
        </h3>
      }
      classCardBody="card-body m-0 p-3"
      content={
        <>
          <div className="d-flex flex-wrap justify-content-start align-items-end">
            <GetTicketsCountItem status={null} filters={filters} />
            <GetTicketsCountItem status={st_nuevo} filters={filters} />
            <GetTicketsCountItem status={st_pendiente} filters={filters} />
            <GetTicketsCountItem status={st_planificar} filters={filters} />
            <GetTicketsCountItem status={st_procesar} filters={filters} />
            <GetTicketsCountItem status={st_asignar} filters={filters} />
            <GetTicketsCountItem
              status={st_validacion_inicial}
              filters={filters}
              label="Val. Inicial"
            />
            <GetTicketsCountItem
              status={st_validacion_final}
              filters={filters}
              label="Val. Final"
            />
            <GetTicketsCountItem status={st_completado} filters={filters} />
            <GetTicketsCountItem status={st_rechazar} filters={filters} />
          </div>
        </>
      }
    />
  )
}

export default GetTicketsCount
